import { render, staticRenderFns } from "./create-banner.vue?vue&type=template&id=5880df28&"
import script from "./create-banner.vue?vue&type=script&lang=js&"
export * from "./create-banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports